import gql from 'graphql-tag';


export const GET_USER_ACCOUNT = gql`
    query getAccount($userId:Int) {
        payment_accounts(where:{user_id:{_eq:$userId}}) {
            id
            stripe_account_id
            payouts_enabled
        }
    }
`;
